import { MRG_COLUMNS } from './pages/mrgReportPage'
import { DEFAULT_PAYMENT_LOGS_SORT_COLUMNS } from './pages/defaultPaymentLogsPage'
import { chargebackColumns } from '../configuredReport/columns/chargebackColumns'
import { pendingDefaultsColumns } from '../configuredReport/columns/pendingDefaultsColumns'

export const MRG_REPORT_COLUMN_OPTIONS = MRG_COLUMNS.map((column) => ({
  id: column.key,
  label: column.label,
}))

export const MRG_REPORT_LOCKED_COLUMN_IDS = ['applicant_id'] as const

export const MRG_REPORT_COLUMN_VISIBILITY_STORAGE_KEY =
  'mrg-report-column-visibility'

export const REVENUE_PAYMENT_LOGS_COLUMN_DEFS = [
  { id: 'payment_log_id', sortKey: 'payment_log_id', label: 'Log Id' },
  { id: 'company_name', sortKey: 'company_name', label: 'Company' },
  { id: 'property_name', sortKey: 'property_name', label: 'Property' },
  { id: 'applicant_id', sortKey: 'applicant_id', label: 'Applicant ID' },
  { id: 'application_id', sortKey: 'application_id', label: 'Application ID' },
  { id: 'first_name', sortKey: 'first_name', label: 'Name' },
  { id: 'special_note', sortKey: 'special_note', label: 'Special Note' },
  { id: 'payment_type', sortKey: 'payment_type', label: 'Payment Type' },
  { id: 'payment_source', sortKey: 'payment_source', label: 'Payment Source' },
  { id: 'auth_code', sortKey: 'auth_code', label: 'Auth Code' },
  { id: 'payment_amount', sortKey: 'payment_amount', label: 'Amount' },
  { id: 'surcharge_fee', sortKey: 'surcharge_fee', label: 'Service Fee' },
  { id: 'total_amount', sortKey: 'payment_amount', label: 'Total Amount' },
  { id: 'payment_status', sortKey: 'payment_status', label: 'Status' },
  { id: 'gateway_status', sortKey: 'gateway_status', label: 'Gateway Status' },
  { id: 'batch_id', sortKey: 'batch_id', label: 'Batch ID' },
  { id: 'funding_batch_id', sortKey: 'funding_batch_id', label: 'Funding Batch ID' },
  { id: 'funding_master_id', sortKey: 'funding_master_id', label: 'Funding Master ID' },
  { id: 'funding_date', sortKey: 'funding_date', label: 'Funding Date' },
  { id: 'lease_start_date', sortKey: 'lease_start_date', label: 'Contract Start' },
  { id: 'created_at', sortKey: 'created_at', label: 'Created Time' },
] as const

export const REVENUE_PAYMENT_LOGS_COLUMN_OPTIONS =
  REVENUE_PAYMENT_LOGS_COLUMN_DEFS.map((column) => ({
    id: column.id,
    label: column.label,
  }))

export const REVENUE_PAYMENT_LOGS_LOCKED_COLUMN_IDS = [
  'payment_log_id',
] as const

export const REVENUE_PAYMENT_LOGS_COLUMN_VISIBILITY_STORAGE_KEY =
  'revenue-payment-logs-column-visibility'

export const DEFAULT_PAYMENT_LOGS_COLUMN_OPTIONS =
  DEFAULT_PAYMENT_LOGS_SORT_COLUMNS.map((column) => ({
    id: column.key,
    label: column.label,
  }))

export const DEFAULT_PAYMENT_LOGS_LOCKED_COLUMN_IDS = [
  'payment_log_id',
] as const

export const DEFAULT_PAYMENT_LOGS_COLUMN_VISIBILITY_STORAGE_KEY =
  'default-payment-logs-column-visibility'

export const CHARGEBACK_REPORT_COLUMN_OPTIONS = chargebackColumns
  .filter((column) => column.id !== 'action')
  .map((column) => ({
    id: column.id,
    label: column.label,
  }))

export const CHARGEBACK_REPORT_LOCKED_COLUMN_IDS = ['pa_id'] as const

export const CHARGEBACK_REPORT_TRAILING_COLUMN_IDS = ['action'] as const

export const CHARGEBACK_REPORT_COLUMN_VISIBILITY_STORAGE_KEY =
  'chargeback-report-column-visibility'

export const PENDING_REIMBURSEMENTS_COLUMN_OPTIONS = pendingDefaultsColumns.map(
  (column) => ({
    id: column.id,
    label: column.label,
  }),
)

export const PENDING_REIMBURSEMENTS_LOCKED_COLUMN_IDS = [
  'applicant_id',
] as const

export const PENDING_REIMBURSEMENTS_COLUMN_VISIBILITY_STORAGE_KEY =
  'pending-defaults-column-visibility'
